<template>
  <div class="dw-footer-main" >
    <div>
      <span><a :href="footerInfo.siteUrl" style="color: #333;"><strong>{{ footerInfo.siteName }}</strong></a>&nbsp;</span>
      <span><a href="/" style="text-decoration: none;color: #333;">{{ footerInfo.siteIcp }}</a>&nbsp;{{ footerInfo.siteMail }}&nbsp;{{ footerInfo.sitePhone }}</span>
    </div>
    <div>
      <span>Copyright</span>
      <span> © {{ footerInfo.years }} <a href="www.gongxueyun.com"><strong>掌淘网络科技（上海）有限公司</strong></a></span>
    </div>
  </div>
</template>
<script>

import API from '@/api/index.js'

export default {
  name: 'DwFooter',
  data () {
    return {
      footerInfo: {
        siteName: '工学云调查问卷',
        siteUrl: 'https://survey.gongxueyun.com',
        siteIcp: '沪ICP备15057510号-4',
        siteMail: 'survey@gongxueyun.com',
        sitePhone: '400-8883518',
        versionInfo: 'survey-web',
        versionNumber: 'V5.0',
        versionBuilt: '20211128',
        years: '2012-2022'
      }
    }
  },
  mounted () {
    // this.queryDWSurveyFooter()
  },
  methods: {
    queryDWSurveyFooter () {
      this.axios.get(API.surveyFooterInfo, {}).then((response) => {
        const resultData = response.data.data
        console.debug(resultData)
        this.footerInfo = resultData
      })
    }
  }
}
</script>

<style scoped>
.dw-footer-main{
  text-align: center;
  font-size: 12px;
  color: grey;
  line-height: 30px;
  padding-top: 0px;
  padding-bottom: 20px;
}
.dw-footer-main a{
  text-decoration: none;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwFooter.vue